export default function AboutSection() {
  return (
    <section id="about" className="py-32 px-20 max-w-[1440px] mx-auto">
      <div className="mb-6">
        <span className="text-sm text-[#9B9B9B]">• Our Story</span>
      </div>

      <div className="grid grid-cols-5 gap-16">
        <div className="col-span-2">
          <h3 className="text-5xl font-normal italic text-[#4A3F35] leading-snug" style={{ fontFamily: 'Crimson Pro, serif' }}>
            Building Tomorrow's<br />
            Mobile Solutions
          </h3>
        </div>

        <div className="col-span-3">
          <div className="space-y-6 max-w-[560px]">
            <p className="text-base text-[#5C5C5C] leading-relaxed">
              At <strong>KOLOS d.o.o.</strong>, we believe that exceptional mobile applications are born from the perfect blend of innovative technology, thoughtful design, and deep understanding of user needs. Our team of seasoned iOS developers brings years of expertise to every project we undertake.
            </p>
            
            <p className="text-base text-[#5C5C5C] leading-relaxed">
              We specialize in creating applications that not only meet the highest standards of performance and security but also deliver intuitive and delightful user experiences. From concept to deployment, we are committed to excellence in every line of code we write.
            </p>
            
            <p className="text-base text-[#5C5C5C] leading-relaxed">
              Our flagship products, including our <strong>VPN application</strong> for enhanced security and privacy, and our <strong>Cleaner application</strong> for device optimization, have helped thousands of users worldwide enjoy safer and more efficient mobile experiences.
            </p>
          </div>

          <div className="flex items-center gap-4 mt-12">
            <div className="flex -space-x-3">
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#8B6F47] to-[#6B5537] border-4 border-white shadow-md"></div>
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#6B5537] to-[#4A3F35] border-4 border-white shadow-md"></div>
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#4A3F35] to-[#3A2E2E] border-4 border-white shadow-md"></div>
              <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#3A2E2E] to-[#2B2B2B] border-4 border-white shadow-md"></div>
            </div>
            <span className="text-[15px] font-medium text-[#5C5C5C]">
              Expert Team of 12+ Developers
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
